import { MenuItem, styled } from "@mui/material";

export const StyledMenuItem = styled(MenuItem)({
    width: '100%',
    '&:hover': {
        backgroundColor: '#dfe3e8',
    },
    fontSize: '13px'
});